import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Mail, MapPin, Building2, Clock, ArrowUpRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const ENTITY = "Sagewise OPC Private Limited";
const EMAIL = "support@codewithsankalp.com";
const ADDRESS = "WeWork, IWF Campus, Survey No. 192, Whitefield Main Road, B Narayanapura, Mahadevapura, Bangalore, KA 560016";

export default function Contact() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#09090B] text-white" data-testid="contact-page">
      <Navbar variant="adult" />

      <section className="relative overflow-hidden border-b border-zinc-900">
        <div className="absolute inset-0 grid-bg-adult opacity-60" />
        <div className="absolute inset-0 grain opacity-40 pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-6 pt-24 pb-14">
          <div className="text-[11px] uppercase tracking-[0.32em] text-amber-400 font-adult-mono mb-3">Get in touch</div>
          <h1 data-testid="contact-title" className="font-adult-heading text-4xl md:text-5xl font-semibold tracking-tight">Contact Us</h1>
          <p className="mt-6 text-zinc-300 leading-relaxed">
            Questions about a course, a payment, or a refund? We're here to help and reply within 24 hours.
          </p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-14 space-y-5">
        <a href={`mailto:${EMAIL}`} data-testid="contact-email" className="block rounded-2xl border border-amber-500/25 bg-amber-500/5 p-6 hover:border-amber-500/50 transition-smooth">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center text-amber-400 shrink-0"><Mail className="w-6 h-6" /></div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 font-adult-mono">Email us</div>
              <div className="font-adult-heading text-xl mt-1 break-all">{EMAIL}</div>
              <div className="text-sm text-zinc-400 mt-1">Support · billing · refunds</div>
            </div>
          </div>
        </a>

        <div className="rounded-2xl border border-zinc-800 bg-[#0d0d0f] p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-2xl bg-zinc-900 border border-zinc-800 flex items-center justify-center text-amber-400 shrink-0"><MapPin className="w-6 h-6" /></div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 font-adult-mono">Registered address</div>
              <div className="text-zinc-200 mt-1 leading-relaxed" data-testid="contact-address">{ADDRESS}</div>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          <div className="rounded-2xl border border-zinc-800 bg-[#0d0d0f] p-6">
            <div className="w-11 h-11 rounded-2xl bg-zinc-900 border border-zinc-800 flex items-center justify-center text-amber-400 mb-3"><Building2 className="w-5 h-5" /></div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 font-adult-mono">Operated by</div>
            <div className="text-zinc-200 mt-1">{ENTITY}</div>
          </div>
          <div className="rounded-2xl border border-zinc-800 bg-[#0d0d0f] p-6">
            <div className="w-11 h-11 rounded-2xl bg-zinc-900 border border-zinc-800 flex items-center justify-center text-amber-400 mb-3"><Clock className="w-5 h-5" /></div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 font-adult-mono">Response time</div>
            <div className="text-zinc-200 mt-1">Within 24 hours · Mon–Sat</div>
          </div>
        </div>

        <div className="rounded-2xl border border-violet-500/30 bg-violet-500/5 p-6 flex items-center justify-between gap-4">
          <div>
            <div className="text-sm text-zinc-200">Enquiring for a company or team?</div>
            <div className="text-xs text-zinc-500 mt-1">Use our B2B form for training &amp; hiring.</div>
          </div>
          <Link to="/companies" data-testid="contact-b2b-link" className="inline-flex items-center gap-2 rounded-full bg-violet-500 hover:bg-violet-400 text-white font-semibold px-5 py-2.5 text-sm transition-smooth shrink-0">
            Companies <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="pt-2">
          <Link to="/" className="text-sm text-zinc-500 hover:text-amber-400 transition-smooth font-adult-mono">← back to home</Link>
        </div>
      </section>

      <Footer variant="adult" />
    </div>
  );
}
